import React, { ReactNode, memo, useEffect, useState } from "react";
import { isNil } from "ramda";
import { useDispatch, useSelector } from "react-redux";
import { useParams } from "react-router-dom";
import Layout from "../../Layout";
import { fetchRequest } from "../../../store/user/actions";
import { ApplicationState } from "../../../store";
import { Container, Grid, Paper } from "@mui/material";
import { fetchRequest as fetchUserGroup } from "../../../store/usergroup/actions";
import Alert from "@mui/lab/Alert";
import useSession from "../../../effects/useSession";
import pageStyles from "../../pageStyles";
import PageHeading from "../../../common/pageHeading/PageHeading";
import UserEditForm from "./UserEditForm";
import SectionWrapper from "../../../common/pageSections/SectionWrapper";

const CREATE = "CREATE";
const UPDATE = "UPDATE";

function UserEdit() {
  const dispatch = useDispatch();
  const classes = pageStyles();

  const { id } = useParams<{ id: string }>();
  const mode = id ? UPDATE : CREATE;
  const isCreate = Boolean(mode === CREATE);
  const session = useSession();
  useEffect(() => {
    dispatch(fetchUserGroup(null));
    !isNil(id) && dispatch(fetchRequest(id));
  }, []);

  const headingText = () => {
    return mode === CREATE ? "New User" : "Edit User";
  };

  return (
    <Layout sessionData={session}>
      <main className={classes.content}>
        <div className={classes.appBarSpacer} />
        <Container maxWidth="lg" className={classes.container}>
          <Grid container spacing={3}>
            <Grid item xs={12} md={12} lg={12}>
              <Paper>
                <PageHeading heading={headingText()} />
              </Paper>
            </Grid>
            <Grid item xs={12}>
              <Paper className={classes.paper}>
                <SectionWrapper title="User Info">
                  <UserEditForm
                    mode={mode}
                    id={id}
                    session={session}
                    isCreate={isCreate}
                  />
                </SectionWrapper>
              </Paper>
            </Grid>
          </Grid>
        </Container>
      </main>
    </Layout>
  );
}
export default UserEdit;
